import React from "react";

import Search from "~/components/Icons/icon-search";
import Button from "~/shared/ui/Fields/Button";
import { useSetLocationData } from "~/hooks/locationData";
import { usePermissions } from "~/shared/context/PermissionContext";

import s from "~/pages/Q/model/rowStyles.less";

interface ActionsProps {
  record: any;
}

const Actions: React.FC<ActionsProps> = ({ record }) => {
  const setData = useSetLocationData(true);
  const { hasPermission } = usePermissions();

  const openViewModal = () => {
    setData("openChildModal", "View", "currentId", record.id);
  };

  return (
    <Button onlyIcon onClick={openViewModal} customClassName={s.search}>
      {hasPermission("quartilesRatings.ratingDataByLine.get") && (
        <Search width="20" height="20" />
      )}
    </Button>
  );
};

export default Actions;
